<template>
  <li class="sheet-item">
    <div class="top-wrap">
      <input type="checkbox" :id="`sheet-chk-${data.ordNo}`" class="chk-hidden" :checked="isChecked" @change="handleCheckboxChange" />
      <label :for="`sheet-chk-${data.ordNo}`" class="inp-check">{{ data.ordNm }}</label>
      <button type="button" class="btn-delete01" @click="$emit('deleteSheet', data.ordNo)" aria-label="주문서 삭제"></button>
    </div>
    <div class="info-wrap">
      <ul class="info-list">
        <li v-for="(item, index) in infoItems" :key="index">
          <span class="info-data-tit">{{ item.title }}</span>
          <span class="info-data">{{ item.data }}</span>
        </li>
      </ul>
    </div>
    <div class="mid-wrap">
      <ul class="thumbnail-wrap">
        <li v-for="(thumb, index) in data.gdsList" :key="index" class="thumbnail" :class="{'sold-out': thumb.buyPossYn === 'N'}">
          <NuxtLink to="javascript:void(0);" @click="handleGdsLinkClick(thumb)">
            <img :src="cu.getFileFullUrl(thumb.cpnTnailImgPath, true)" :alt="thumb.hcDspGdsCd">
          </NuxtLink>
        </li>
      </ul>
      <div class="order-btn-wrap">
        <button type="button" class="btn md" @click="$emit('placeOrder', data)">주문하기</button>
      </div>
    </div>
    <div v-if="data.buyNdmtGdsInclYn === 'Y'" class="botton-wrap">
      <div class="alert-msg">
        <p>
          일부 상품은 <em class="text-error">품절 또는 구매 제한으로 주문이 불가</em>합니다. 해당 상품을 제외 후 주문이 진행됩니다.
        </p>
      </div>
    </div>
  </li>
</template>
<script lang="ts" setup>
import { defineProps, defineEmits, computed } from 'vue'
import type { TmpSaveOrdDto, TmpSaveGdsDto } from '@/types/order/backend-dto-types';
import { ORDER_CODE } from "@/constants/hconMessageConstants";
const { showAlert } = usePopup()

const props = defineProps({
  isChecked: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object as () => TmpSaveOrdDto,
    required: true
  }
})

const emit = defineEmits<{
  (e: 'update:isChecked', value: boolean): void
  (e: 'deleteSheet', ordNo: string): void
  (e: 'placeOrder', item: any): void
}>()

const handleCheckboxChange = (e: Event) => {
  const target = e.target as HTMLInputElement | null

  if (target && 'checked' in target) {
    emit('update:isChecked', target.checked)
  }
}

const formatDate = (dateStr: string | undefined) => {
  if(!dateStr || dateStr.length !== 8) return dateStr || '-';
  return dateStr.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
}
const formatTelNo = (telNoStr: string | undefined) => {
  if(!telNoStr) return '-';
  if(telNoStr.length === 8) {
    return telNoStr.replace(/(\d{4})(\d{4})/, '$1-$2');
  }
  return telNoStr.replace(/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/, '$1-$2-$3');
}


const infoItems = computed(() => {
  if (!props.data) return []

  return [
    { title: '임시저장 일자', data: HconCommonUtils.format.date(props.data.tmpSaveDtm) },
    { title: '발신번호', data: formatTelNo(props.data.sndrTelno) },
    { title: '발신유형', data: props.data.hcCpnSndMnsNm },
    { title: '발신방식', data: props.data.hcCpnSndPntmNm },
    { title: '수신자', data: `${props.data.rcvrCnt}명`},
  ].filter(item => item.data)
})

const handleGdsLinkClick = (thumb:TmpSaveGdsDto) => {
  // 품절 체크
  if(thumb.buyPossYn === 'N') {
    showAlert({
      title: '알림',
      message: ORDER_CODE.ALT_HCON_9067
    });
    return;
  }
  // 상품 상세 이동
  navigateTo({ path : `/pc/product/detail/${thumb.hcDspGdsCd}`})
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
</style>